module.exports = __webpack_public_path__ + "img/dummyprod8@1x.9b7e06e3.png";